import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogService } from "@nebular/theme";
import { map } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import {
  convertTimestamp,
  convertTimestampsPipe,
} from "../../@core/utils/convertTimestamps.service";
import CourseRating from "../../models/course-rating.model";
import Course from "../../models/course.model";
import { CourseRatingService } from "../../services/course-rating.service";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import { remove } from "lodash";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-view-course-rating",
  styleUrls: ["./view-course-rating.component.scss"],
  templateUrl: "./view-course-rating.component.html",
})
export class ViewCourseRatingComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  @Input() course = new Course();
  @Input() mode?: string = "student";
  @Input() courseId?: string = "";

  ratingForm: FormGroup;
  submitted = false;
  loading = false;
  done = false;
  cursor: any;

  ratings?: CourseRating[] = [];
  myRatings?: CourseRating[];
  rating: CourseRating = new CourseRating();
  ratingId = "";
  ratingSelects = [1, 2, 3, 4, 5];
  ratingSelected: number = 1;

  isInit = false;

  uid = "anonymous";
  dbPath: string = "";

  constructor(
    private fb: FormBuilder,
    private ratingService: CourseRatingService,
    private userService: UserService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    if (this.courseId) {
      //this.getFirst();
    }

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.getMyRatings(user.uid);
          this.getFirst(user.uid);
        } else {
          this.uid = "";
          this.getFirst("anonymous");
        }
      });

    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.ratingForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
    });
  }

  ngOnDestroy() {
    //console.log("Items destroyed");
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFirst(uid): void {
    this.loading = true;

    this.ratingService
      .getFirst(this.courseId, 3)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];
        } else {
          this.cursor = null;
          this.done = true;
        }

        //const uid = this.uid;
        querySnapshot.forEach((doc) => {
          let data = new CourseRating();
          data = doc.data();
          if (data.createdBy != uid) {
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);
            this.ratings.push(data);
          }
        });

        this.loading = false;
      })
      .catch((error) => {});
  }

  getMore(): void {
    this.loading = true;

    this.ratingService
      .getMore(this.courseId, 10, this.cursor)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];
        } else {
          this.cursor = null;
          this.done = true;
        }

        querySnapshot.forEach((doc) => {
          let data = new CourseRating();
          data = doc.data();
          if (data.createdBy != this.uid) {
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);
            this.ratings.push(data);
          }
        });

        this.loading = false;
      })
      .catch((error) => {
        //console.log("getMoreQnAs/Error: ", error);
      });
  }

  getMyRatings(uid): void {
    this.loading = true;
    this.ratingService
      .getMyRatings(this.courseId, uid)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$),
        convertTimestampsPipe()
      )
      .subscribe((data) => {
        this.loading = false;
        this.myRatings = data;
      });
  }

  createRating() {
    this.loading = true;
    this.submitted = true;

    this.rating.courseId = this.courseId;
    this.rating.rating = this.ratingSelected;
    this.rating.refTitle = this.course.title;
    this.rating.toUid = this.course.createdBy;

    this.ratingService
      .createRating(this.rating)
      .then((result) => {
        this.ratingId = result;
        this.rating.id = result;

        this.calculatorRating(this.ratingSelected, "create");

        this.rating.title = "";
        this.rating.description = "";

        this.loading = false;
        this.submitted = false;
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  deleteRating(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.ratingService
            .deleteRating(item.courseId, item.id)
            .then((result) => {
              this.calculatorRating(item.rating, "delete");
              this.loading = false;
              this.submitted = false;
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  onDelete(value) {
    if (value) {
      remove(this.ratings, (e) => {
        return e.id == value;
      });
    }
  }

  private calculatorRating(rating, mode) {
    switch (rating) {
      case 1:
        if (!this.course.noRating1) {
          this.course.noRating1 = 0;
        }
        mode === "create" ? this.course.noRating1++ : this.course.noRating1--;
        break;

      case 2:
        if (!this.course.noRating2) {
          this.course.noRating2 = 0;
        }
        mode === "create" ? this.course.noRating2++ : this.course.noRating2--;
        break;

      case 3:
        if (!this.course.noRating3) {
          this.course.noRating3 = 0;
        }
        mode === "create" ? this.course.noRating3++ : this.course.noRating3--;
        break;

      case 4:
        if (!this.course.noRating4) {
          this.course.noRating4 = 0;
        }
        mode === "create" ? this.course.noRating4++ : this.course.noRating4--;
        break;

      case 5:
        if (!this.course.noRating5) {
          this.course.noRating5 = 0;
        }
        mode === "create" ? this.course.noRating5++ : this.course.noRating5--;
        break;
      default:
        break;
    }

    if (!this.course.noRating) {
      this.course.noRating = 0;
    }
    mode === "create" ? this.course.noRating++ : this.course.noRating--;

    this.course.rating = Math.round(
      (this.course.noRating1 +
        this.course.noRating2 * 2 +
        this.course.noRating3 * 3 +
        this.course.noRating4 * 4 +
        this.course.noRating5 * 5) /
        this.course.noRating
    );
  }
}
